import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function initials(name: string, address = "") {
  const value = name.trim() || address.trim();
  if (!value) return "?";
  const parts = value.split(/\s+/);
  return parts.length > 1 ? `${parts[0]![0]}${parts.at(-1)![0]}`.toUpperCase() : value.slice(0, 2).toUpperCase();
}

const avatarColors = ["#26364f", "#33445d", "#28425f", "#3b4559", "#2d4861", "#394358"];
export function avatarColor(value: string) {
  let hash = 0;
  for (const character of value) hash = (hash * 31 + character.charCodeAt(0)) | 0;
  return avatarColors[Math.abs(hash) % avatarColors.length]!;
}
